import React from 'react';
import styled from '@emotion/styled';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import * as _ from 'lodash';
import { USER_PROFILE } from '../../../constants/define/translation';
import { CommonColumn } from '../shared-column';

const getClubInitials = (club: any) => {
  const nameClub = club?.clubFamily?.name.toLowerCase();
  switch (nameClub) {
    case 'driver':
      return 'D';
    case 'fairway':
    case 'wedge':
      return club?.clubType?.type;
    case 'rescue':
      return club?.clubType?.type ? club?.clubType?.type.replace('Rescue', 'H').replace(/\s/g, '') : 'H';
    case 'irons':
      return club?.clubType?.type ? `${club?.clubType?.type}i` : '';
    case 'putter':
      return 'P';
    case 'others':
      return club?.clubType?.type;
    case 'ball':
      return 'B';
    default:
      return '';
  }
};

export const WITBTable = (prop: any) => {
  const { userProfile } = prop;
  const { witbs } = userProfile;
  const { t } = useTranslation(USER_PROFILE);
  const { Column } = Table;
  const loading = false;

  let records: any = [];

  if (witbs && witbs.length) {
    witbs.map((val: any) => {
      const data = {
        type: getClubInitials(val),
        model: _.result(val, 'modelName.name', ''),
        brand: _.result(val, 'manufacturer.name', ''),
        status: val.inBag ? 'active' : 'inactive',
      };
      records.push(data);
      return val;
    });
  }
  records = _.sortBy(records, element => {
    const type = element?.type;
    const rank: any = {
      D: 1,
      FW: 2,
      '1FW': 3,
      '2FW': 4,
      '3FW': 5,
      '4FW': 6,
      '5FW': 7,
      '6FW': 8,
      '7FW': 9,
      '8FW': 10,
      '9FW': 11,
      H: 12,
      '1H': 13,
      '2H': 14,
      '3H': 15,
      '4H': 16,
      '5H': 17,
      '6H': 18,
      '7H': 19,
      '8H': 20,
      '9H': 21,
      i: 22,
      '1i': 23,
      '2i': 24,
      '3i': 25,
      '4i': 26,
      '5i': 27,
      '6i': 28,
      '7i': 29,
      '8i': 30,
      '9i': 31,
      PWi: 32,
      SWi: 33,
      PW: 34,
      AW: 35,
      SW: 36,
      LW: 37,
      P: 38,
      B: 39,
    };

    return rank[type];
  });
  return (
    <>
      <StyledTable dataSource={records} loading={loading} rowKey="id" pagination={false}>
        <Column
          title={t('table.title.type')}
          width={200}
          dataIndex="type"
          key="type"
          render={value => <CommonColumn value={value} />}
          align="center"
        />
        <Column
          title={t('table.title.model')}
          width={200}
          dataIndex="model"
          key="model"
          render={value => <CommonColumn value={value} />}
          align="center"
        />
        <Column
          title={t('table.title.brand')}
          width={200}
          dataIndex="brand"
          key="brand"
          render={value => <CommonColumn value={value} />}
          align="center"
        />
        <Column
          title={t('table.title.status')}
          width={200}
          dataIndex="status"
          key="status"
          render={value => <CommonColumn value={value} />}
          align="center"
        />
      </StyledTable>
    </>
  );
};

const StyledTable = styled(Table)`
  .fcmToken > div {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .tableGolf {
    padding: 0 1rem;
  }
`;
